import { render, staticRenderFns } from "./remarks.vue?vue&type=template&id=62508df2&scoped=true&"
import script from "./remarks.vue?vue&type=script&lang=js&"
export * from "./remarks.vue?vue&type=script&lang=js&"
import style0 from "./remarks.vue?vue&type=style&index=0&id=62508df2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62508df2",
  null
  
)

export default component.exports